const middleware = {}

middleware['projects'] = require('@/middleware/projects.js');
middleware['projects'] = middleware['projects'].default || middleware['projects']

export default middleware
